var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#FAFAFD"}},[_c('Header',{ref:"ambiiHeader"}),_vm._v(" "),_c('v-main',{staticClass:"px-4 pt-0"},[_c('nuxt')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('OnProgress',{attrs:{"message":_vm.progressMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }